import React from "react";
import Testimonial from "../components/Testimonial";

const TestimonialsSection = ({ fields }) => {
    if (!fields) return null;
    return <Testimonial data={fields} />;
};

export default TestimonialsSection;

